import { Button } from "@heroui/react"
import { ErrorPage } from "@components"
import { Link } from "react-router-dom"
import { ReactComponent as PlugSvg } from "@svgs/graphs/plug.svg"
import PropTypes from "prop-types"

const NetworkError = ({ code = 500 }) => (
  <ErrorPage
    errorCode={code}
    title="Network Error"
    subTitle="Sorry, there was a problem connecting to the server. Most likely you temporarily lost your internet connection."
  >
    <Button size="lg" variant="flat" className="mt-4 font-semibold text-white bg-blue-500">
      <Link to={`/`}>Take me home</Link>
    </Button>

    <PlugSvg />
  </ErrorPage>
)

NetworkError.propTypes = {
  code: PropTypes.number,
}

export default NetworkError
